<template>
  <div class="flex items-center gap-8 flex-nowrap">
    <q-avatar
      :size="size"
      class="!bg-neutral-5 dark:!bg-white/10 border-neutral-10 border border-solid "
      v-bind="attrs"
    >
      <q-img v-if="foto" no-transition :src="foto" no-spinner />
      <q-icon v-else name="person" size="1.5rem" class="text-neutral-100/40  -ml-2 -mt-2"></q-icon>
    </q-avatar>

    <p
      v-if="nome"
      class="text-paragraph-2 md:!text-paragraph-3 md:!text-12 capitalize one-line"
      :class="classText"
    >
      {{ nome }}
    </p>
  </div>
</template>
<script>
export default { inheritAttrs: false }
</script>

<script setup>
import { useAttrs } from 'vue'

const attrs = useAttrs()
defineProps({
  foto: String,
  nome: String,
  classText: String,
  size: {
    type: String,
    default: '1.75rem',
  },
})
</script>

<style lang="scss" scoped></style>
